import styled from 'styled-components';

export const InfoText = styled.span`
  color: var(--text-secondary-color);
`;
